import Components from "slotworks/components/components";
import GameState from "slotworks/model/game-state";
import State from "slotworks/state-machine/states/state";

export default class ShowTotalWin extends State {

    public onEnter(): void {
        const totalWin: number = GameState.getCurrentGame().getCurrentTotalWin();

        Components.celebrateWin.totalWin(totalWin).then(() => this.complete());
    }
}
